var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSavedOff = function SvgIconSavedOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14 35.595 6.932-6.262.194-.167a5.3 5.3 0 0 1 6.98.23l6.394 5.983V7H14zm24.5 6.008-.004.105c-.078 1.034-1.297 1.562-2.104.913l-.08-.068-10.939-10.237a1.3 1.3 0 0 0-1.76-.014L12.172 42.638l-.08.067c-.812.63-2.012.097-2.088-.928L10 41.674V5.6A2.6 2.6 0 0 1 12.6 3h23.3l.266.014A2.6 2.6 0 0 1 38.5 5.6z"
  })));
};
export default SvgIconSavedOff;